import { z } from 'zod';

import { type IEndpointSchema, makeEndpoint } from '../common';

const BulkUpdateCategorySchema = z.object({
  id: z.string().uuid().optional().nullable(),
  name: z.string(),
  order: z.number(),
});

export type IBulkUpdateCategorySchema = z.infer<typeof BulkUpdateCategorySchema>;
export const UpdateCategoriesDataSchema = z.object({
  categories: z.array(BulkUpdateCategorySchema),
});

export const UpdateCategoriesEndpoint = makeEndpoint({
  method: 'PATCH',
  url: ({ brandId }: { brandId: string }) => `v1/brands/${brandId}/categories`,
  responseSchema: z.void(),
  requestSchema: UpdateCategoriesDataSchema,
});

export type IUpdateCategoriesEndpoint = IEndpointSchema<typeof UpdateCategoriesEndpoint>;
